<template>
  <HeaderContent title="Available Rooms" />

  <ActionContent
    ctaText="Check"
    :cta="false"
    :filter-modal="false"
    @action="fetchAvailableRooms"
    v-model:start-date="startDate"
    v-model:end-date="endDate"
    :filterDate="true"
    @showFilter="modalFilter = !modalFilter"
    @search-query="fetchAvailableRooms"
  />

  <!-- Statistik kategori -->
  <StatisticData title="Room Available:" :data="statistics" />

  <!-- Tabel daftar rooms -->
  <DataTable :data="availableList" :header="headers" :currentPage="currentPage">
  </DataTable>
</template>

<script>
import { ref, inject, onMounted, watch } from "vue";

import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import StatisticData from "@/components/StatisticData.vue";
import DataTable from "@/components/DataTable.vue";

// Category Icons (seperti RoomIndex)
import iconDeluxe from "../../../public/icons/business-value.svg";
import iconSuperDeluxe from "../../../public/icons/dorm-room.svg";
import iconStudio from "../../../public/icons/space-station-moon.svg";
import iconHoneymoon from "../../../public/icons/rings-wedding.svg";
import iconFamily from "../../../public/icons/family-pants.svg";
import iconDefault from "../../../public/icons/home-location.svg";
import iconBed from "../../../public/icons/bed-bunk.svg";

export default {
  components: {
    HeaderContent,
    ActionContent,
    StatisticData,
    DataTable,
  },

  setup() {
    const repositories = inject("repositories");
    const roomRepository = repositories.rooms;

    const statistics = ref([]);
    const availableList = ref([]);

    const date = new Date();
    const todayStr = `${date.getFullYear()}-${String(
      date.getMonth() + 1,
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
    
    const tomorrow = new Date(date);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowStr = `${tomorrow.getFullYear()}-${String(
      tomorrow.getMonth() + 1,
    ).padStart(2, "0")}-${String(tomorrow.getDate()).padStart(2, "0")}`;

    const startDate = ref(todayStr);
    const endDate = ref(tomorrowStr);

    const modalFilter = ref(false);
    const currentPage = ref(1);

    // Icon Map kategori
    const iconMap = {
      Deluxe: iconDeluxe,
      "Super Deluxe": iconSuperDeluxe,
      Studio: iconStudio,
      "Honeymoon Suite": iconHoneymoon,
      Family: iconFamily,
    };

    const defaultIcon = iconDefault;

    // Table Header
    const headers = ref([
      {
        key: "room_category",
        label: "Category",
        sortable: true,
        tdClass: "text-left w-25 px-5",
      },
      {
        key: "code",
        label: "Room Number",
        sortable: true,
        tdClass: "text-center",
      },
      {
        key: "status_room_available",
        label: "Status",
        sortable: true,
        tdClass: "text-center",
      },
    ]);

    // Fetch data from BE
    const fetchAvailableRooms = async (search = "") => {
      try {
        const res = await roomRepository.availability({
          check_in: startDate.value,
          check_out: endDate.value,
          keyword: search,
        });

        const data = res.data;

        // Stat kategori
        const stats = data.categories.map((c) => ({
          label: "",
          key: c.category_name,
          value: c.count,
          icon: iconMap[c.category_name] || defaultIcon,
        }));

        const totalRooms = data.categories.reduce(
          (acc, curr) => acc + curr.count,
          0,
        );
        stats.unshift({
          label: "",
          key: "Total Room",
          value: totalRooms,
          icon: iconBed,
          iconColor: "blue",
        });

        statistics.value = stats;

        // Data table
        availableList.value = data.rooms.map((r) => ({
          room_category: r.room_category ?? {
            name: r.room_category_name ?? "Unknown",
            color: r.color ?? "#555",
          },
          code: r.code,
          status_room_available: "Available",
        }));

        console.log("Available Rooms Data:", availableList.value);
      } catch (error) {
        console.error("Error fetch availability:", error);
      }
    };

    const searchData = async (keyword) => {
      await roomRepository
        .search_availability(keyword, startDate.value, endDate.value)
        .then((res) => {
          availableList.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    watch([startDate, endDate], ([newStart, newEnd]) => {
      if (new Date(newStart) > new Date(newEnd)) {
        endDate.value = newStart;
      } else {
        fetchAvailableRooms();
      }
    });
    onMounted(fetchAvailableRooms);

    return {
      startDate,
      endDate,
      modalFilter,
      currentPage,
      statistics,
      availableList,
      headers,
      fetchAvailableRooms,
      searchData,
    };
  },
};
</script>
